import React, {useState, useEffect} from "react";


import { Checkbox, Form } from "rsuite";

const ControlledCheckbox = ({children, defaultValue = false, value, onChange, ...props}) => {
    const [_value, _setValue] = useState(defaultValue);

    useEffect(() => {
        if (value !== undefined) {
            _setValue(value);
        }
    }, [value]);

    return <Form.Control
        accepter={Checkbox}
        value={_value}
        checked={_value}
        defaultChecked={defaultValue}
        onChange={() => {
            _setValue(!_value);
            onChange && onChange(!_value);
        }}
        {...props}
    >
        {children}
    </Form.Control>
};

export default ControlledCheckbox;